"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessRequestStatus = void 0;
var AccessRequestStatus;
(function (AccessRequestStatus) {
    AccessRequestStatus["REQUESTED"] = "REQUESTED";
    AccessRequestStatus["REJECTED"] = "REJECTED";
    AccessRequestStatus["ACCEPTED"] = "ACCEPTED";
})(AccessRequestStatus = exports.AccessRequestStatus || (exports.AccessRequestStatus = {}));
